import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { postService } from 'services';

const adapter = createEntityAdapter({});

const slice = createSlice({
  name: 'postDetails',
  initialState: adapter.getInitialState({
    busy: false,
  }),
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setBusy(state, action) {
      state.busy = action.payload;
    },
  },
});

const fetchPostDetails = (params = {}) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await postService.fetchPostDetails(params);
    dispatch(slice.actions.addOne(resData));
  } catch (err) {
    dispatch(slice.actions.addOne({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchSharePostDetails = (params = {}) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await postService.fetchSharePostDetails(params);
    dispatch(slice.actions.addOne(resData));
  } catch (err) {
    dispatch(slice.actions.addOne({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const actions = {
  fetchPostDetails,
  fetchSharePostDetails,
};

const selectors = {
  ...adapter.getSelectors((state) => state.postDetails),
};

export { actions, selectors };

export default slice.reducer;
